import { render, staticRenderFns } from "./fieldsEditor.vue?vue&type=template&id=02a8d82c&scoped=true"
import script from "./fieldsEditor.vue?vue&type=script&lang=js"
export * from "./fieldsEditor.vue?vue&type=script&lang=js"
import style0 from "./fieldsEditor.vue?vue&type=style&index=0&id=02a8d82c&prod&lang=scss"
import style1 from "./fieldsEditor.vue?vue&type=style&index=1&id=02a8d82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a8d82c",
  null
  
)

export default component.exports